import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { XIcon } from 'lucide-react';
import { SHOW_PURCHASE_NOTIFICATIONS } from '../data/config';
import { recentPurchases } from '../data/recentPurchases';
import { Pumpkin } from './HalloweenDecor';
const FIRST_DELAY = 8000;
const VISIBLE_FOR = 5000;
const GAP = 14000;

/** Aviso discreto de compras recientes, abajo a la izquierda. Se puede cerrar. */
export function PurchaseNotification() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (!SHOW_PURCHASE_NOTIFICATIONS || dismissed || recentPurchases.length === 0) return;
    let hideTimer: number;
    const show = () => {
      setVisible(true);
      hideTimer = window.setTimeout(() => {
        setVisible(false);
        setIndex(current => (current + 1) % recentPurchases.length);
      }, VISIBLE_FOR);
    };
    const firstTimer = window.setTimeout(show, FIRST_DELAY);
    const loop = window.setInterval(show, VISIBLE_FOR + GAP);
    return () => {
      window.clearTimeout(firstTimer);
      window.clearTimeout(hideTimer);
      window.clearInterval(loop);
    };
  }, [dismissed]);
  if (!SHOW_PURCHASE_NOTIFICATIONS || dismissed || recentPurchases.length === 0) return null;
  const purchase = recentPurchases[index];
  return <div className="pointer-events-none fixed bottom-[calc(96px+env(safe-area-inset-bottom))] left-3 right-3 z-30 sm:right-auto md:bottom-5 md:left-5" data-id="element-195" data-mp="19p4zt52lltn0">
      <AnimatePresence data-id="element-196" data-mp="1ei7xnpeerp90">
        {visible && <motion.div key={index} role="status" initial={{
        opacity: 0,
        y: 12,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 8
      }} transition={{
        duration: 0.22,
        ease: [0.23, 1, 0.32, 1]
      }} className="pointer-events-auto flex max-w-sm items-center gap-3 rounded-2xl bg-white p-3 pr-2 shadow-soft ring-1 ring-brand-violet/10" data-id="element-197" data-mp="zrqvu4xv2xbl">
            <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-brand-mint" data-id="element-198" data-mp="2xgw38k7aubs4">
              <Pumpkin className="w-7 text-brand-orange" data-id="element-199" data-mp="2sm9oc720e13a" />
            </span>
            <p className="min-w-0 flex-1 text-sm leading-snug text-brand-ink" data-id="element-200" data-mp="2np9hvv18ywbn">
              <strong className="text-brand-violet" data-id="element-201" data-mp="2jopkcqcrhqoz">{purchase.initials}</strong> de {purchase.city} compró el{' '}
              <span className="font-bold" data-id="element-202" data-mp="3gcvyc3vkpvfx">Kit Disfraces de Halloween</span>
              <span className="mt-0.5 block text-xs text-brand-ink/60" data-id="element-203" data-mp="3bfnezzyovld3">{purchase.timeAgo}</span>
            </p>
            <button type="button" onClick={() => setDismissed(true)} aria-label="Cerrar avisos de compras" className="self-start rounded-lg p-1.5 text-brand-ink/50 transition-colors duration-150 ease-out hover:bg-brand-cream hover:text-brand-violet focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-violet" data-id="element-204" data-mp="37bo3jvs9ncql">
              <XIcon className="h-4 w-4" data-id="element-205" data-mp="1r13l1uakh87x" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}